import React from "react";
import "./AddressDisplay.scss";
import * as _ from "lodash-es";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";

type Props = {
    address?: any;
    showName?: boolean;
    showCompanyName?: boolean;
    showPhone?: boolean;
    hideMobile?: boolean;
    hideEmail?: boolean;
    hideFax?: boolean;
    hideCity?: boolean;
    hideState?: boolean;
    hidePostalCode?: boolean;
    hideCountry?: boolean;
    prefix?: string;
    className?: string;
    showInternalId?: boolean;
    removeDuplicateNameCompany?: boolean;
    nameTag?: "h1" | "h2" | "h3" | "h4" | "h5";
    wrapperTag?: "div" | "span";
};

const AddressDisplay: React.FC<Props> = (props) => {
    const address = _.get(props, "address", {});

    if (_.isNil(address)) {
        return null;
    }

    const prefix = props.prefix ? props.prefix : "";

    const name = _.get(address, `${prefix}name`, "") || "";
    const company_name = _.get(address, `${prefix}company_name`, "") || "";
    const address_line_one = _.get(address, `${prefix}address_line_one`, "") || "";
    const address_line_two = _.get(address, `${prefix}address_line_two`, "") || "";
    const address_line_three = _.get(address, `${prefix}address_line_three`, "") || "";
    const city = _.get(address, `${prefix}city`, "") || "";
    const state = _.get(address, `${prefix}state`, "") || "";
    const postal_code = _.get(address, `${prefix}postal_code`, "") || "";
    const country = _.get(address, `${prefix}country`, "") || "";
    const phone = _.get(address, `${prefix}phone`, "") || "";
    const fax = _.get(address, `${prefix}fax`, "") || "";
    const cell = _.get(address, `${prefix}cell`, "") || "";
    const email = _.get(address, `${prefix}email`, "") || "";
    const internalId = _.get(address, `${prefix}address_internal_id`, "") || "";

    const state_seperator = state && state.length && !props.hideState ? "," : "";

    let nameSameAsCompany = (name || "").toLowerCase() === (company_name || "").toLowerCase();

    if (name && !name.length) {
        nameSameAsCompany = false;
    }

    let nameLine = <div>{name}</div>;

    if (props.nameTag) {
        nameLine = <OwTitle title={name} tag={props.nameTag} disableTranslation={true} />;
    }

    let companyNameLine = <div>{company_name}</div>;

    if (props.nameTag && !nameSameAsCompany) {
        companyNameLine = <OwTitle title={company_name} tag={props.nameTag} disableTranslation={true} />;
    }

    const WrapperTag = props.wrapperTag ? props.wrapperTag : "div";

    return (
        <WrapperTag className={props.className + " AddressDisplay " + (address.isBlank ? "d-none" : "")}>
            {props.showName ? name : null}
            {props.showCompanyName && !nameSameAsCompany ? companyNameLine : null}
            <div>{address_line_one}</div>
            <div>{address_line_two}</div>
            <div>{address_line_three}</div>
            <div>
                {props.hideCity ? "" : city}
                {state_seperator} {props.hideState ? "" : state} {props.hidePostalCode ? "" : postal_code}
            </div>
            <div>{country}</div>
            <div className={"mt-3 " + (props.showPhone ? "" : "d-none")}>
                <div>
                    <OwLabel noBottomMargin={true} title={"phone"} postText={":"} isBold={true} className={"me-1"} />
                    {phone}
                </div>
                {props.hideFax ? null : (
                    <div>
                        <OwLabel noBottomMargin={true} title={"fax"} postText={":"} isBold={true} className={"me-1"} />
                        {fax}
                    </div>
                )}
                {props.hideMobile ? null : (
                    <div>
                        <OwLabel noBottomMargin={true} title={"mobile"} postText={":"} isBold={true} className={"me-1"} />
                        {cell}
                    </div>
                )}
                {props.hideEmail ? null : (
                    <div>
                        <OwLabel noBottomMargin={true} title={"email"} postText={":"} isBold={true} className={"me-1"} />
                        {email}
                    </div>
                )}
                {props.showInternalId && internalId ? <div className={"text-muted"}>{internalId}</div> : null}
            </div>
        </WrapperTag>
    );
};

export default AddressDisplay;
